import { RobotTaskScheduler } from "src/models/robot";
import { createEntityModel } from "src/store/models/entity/_shared";

export const RobotTaskSchedulerEntityModel =
  createEntityModel<RobotTaskScheduler>();
